"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createVueComponent = _interopRequireDefault(require("../createVueComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Glasses = (0, _createVueComponent.default)('GlassesIcon', [['circle', {
  cx: '6',
  cy: '15',
  r: '4'
}], ['circle', {
  cx: '18',
  cy: '15',
  r: '4'
}], ['path', {
  d: 'M14 15a2 2 0 00-2-2 2 2 0 00-2 2'
}], ['path', {
  d: 'M2.5 13L5 7c.7-1.3 1.4-2 3-2'
}], ['path', {
  d: 'M21.5 13L19 7c-.7-1.3-1.5-2-3-2'
}]]);
var _default = Glasses;
exports.default = _default;